export default "https://cdn-static.gokick.com/assets/7f5563240f0a87948aacfb3375d791c4357d9b8c/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";